<template>
  <div class="flex-1 flex-column h-100">
    <div class="flex plr-10 border-ra align-center bg-ff">
      <div class="title flex align-center justify-center mr-20 mtb-10 ">
        <div class="decoration-line mr-5"></div>
        <div class="font-16-46b8b0 font-bold">{{titleName}}</div>
      </div>
      <div class="flex align-center" v-if="parseInt(define) !== 2">
        <!--客户预算-->
        <div v-if="parseInt(define) !== 1" class="flex">
          <div class="flex" v-if="budgetId">
            <div v-if="permission.includes('basic')" class="flex">
              <div class="flex align-center mr-5 " :class="status === 1 || status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(0)" @mouseleave="leave1(0)" @click="selectTemplate">
                <img :src="status === 1 || status === 2 ? '/static/images/xuanzemuban-hui.png' :btnIndex === 0 ? '/static/images/xuanzemuban-bai.png' : '/static/images/xuanzemuban.png'" class="icon-14 mr-5" alt="">
                <div>选择模板</div>
              </div>
              <div class="flex align-center mr-5" @click="importBudget" :class="status === 2 || status === 1 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(1)" @mouseleave="leave1(1)">
                <img :src="status === 2 || status === 1 ? '/static/images/daoru-hui.png' : btnIndex === 1 ? '/static/images/daoru-bai.png' : '/static/images/daoru.png'" class="icon-14 mr-5" alt="">
                <div>导入预算</div>
              </div>
              <div class="flex align-center mr-5 " :class="status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 2 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(2)" @mouseleave="leave1(2)" @click="exportBudget">
                <img :src="status === 2 ? '/static/images/daochu-hui.png' : btnIndex === 2 ? '/static/images/daochu-bai.png' : '/static/images/daochu.png'" class="icon-14 mr-5" alt="">
                <div>导出预算</div>
              </div>
            </div>
          </div>
          <div class="flex" v-else>
            <div v-if="permission.includes('basic')" class="flex align-center mr-5 " :class="status === 1 || status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(0)" @mouseleave="leave1(0)" @click="selectTemplate">
              <img :src="status === 1 || status === 2 ? '/static/images/xuanzemuban-hui.png' :btnIndex === 0 ? '/static/images/xuanzemuban-bai.png' : '/static/images/xuanzemuban.png'" class="icon-14 mr-5" alt="">
              <div>选择模板</div>
            </div>
            <div v-if="permission.includes('basic')" class="flex align-center mr-5" @click="importBudget" :class="status === 2 || status === 1 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(1)" @mouseleave="leave1(1)">
              <img :src="status === 2 || status === 1 ? '/static/images/daoru-hui.png' : btnIndex === 1 ? '/static/images/daoru-bai.png' : '/static/images/daoru.png'" class="icon-14 mr-5" alt="">
              <div>导入预算</div>
            </div>
            <div class="flex align-center mr-5 font-12-e2 btn-24-border-e2-f3f4f7" v-for="(item, index) in btnLeft" v-if="permission.indexOf(item.permission) !== -1" :key="index">
              <img :src="item.icon" class="icon-14 mr-5" alt="">
              <div>{{item.name}}</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="flex" v-if="budgetId">
            <div class="flex align-center mr-5 " :class="status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 3 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(3)" @mouseleave="leave1(3)" @click="sumSave" v-if="!define && permission.includes('summary')">
              <img :src="status === 2 ? '/static/images/huizong-hui.png' : btnIndex === 3 ? '/static/images/huizong-bai.png' : '/static/images/huizong.png'" class="icon-14 mr-5" alt="">
              <div>汇总保存</div>
            </div>
            <div class="flex align-center mr-5 " :class="btnIndex === 4 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(4)" @mouseleave="leave1(4)" @click="isReportShow = true" v-if="permission.includes('print')">
              <img :src="btnIndex === 4 ? '/static/images/daying-bai.png' : '/static/images/daying.png'" class="icon-14 mr-5" alt="">
              <div>打印</div>
            </div>
            <div class="flex" v-if="!parseInt(define)">
              <div v-if="permission.includes('lockSave')" class="flex">
                <div class="flex align-center mr-5 " :class="btnIndex === 5 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(5)" @mouseleave="leave1(5)" v-if="status === 1" @click="changeStatus(3)">
                  <img :src="btnIndex === 5 ? '/static/images/chehui-bai.png' : '/static/images/chehui.png'" class="icon-14 mr-5" alt="">
                  <div>撤回预算</div>
                </div>
                <div class="flex align-center mr-5 " :class="btnIndex === 8 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(8)" @mouseleave="leave1(8)" v-if="status === 2" @click="changeStatus(4)">
                  <img :src="btnIndex === 8 ? '/static/images/chehui-bai.png' : '/static/images/chehui.png'" class="icon-14 mr-5" alt="">
                  <div>撤回预算存档</div>
                </div>
                <div class="flex align-center mr-5 " :class="btnIndex === 7 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(7)" @mouseleave="leave1(7)" v-if="status === 1" @click="changeStatus(2)">
                  <img :src="btnIndex === 7 ? '/static/images/cundang-bai.png' : '/static/images/cundang.png'" class="icon-14 mr-5" alt="">
                  <div>结算存档</div>
                </div>
                <div class="flex align-center mr-5 " :class="btnIndex === 6 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(6)" @mouseleave="leave1(6)" v-if="status !== 1 && status !== 2" @click="changeStatus(1)">
                  <img :src="btnIndex === 6 ? '/static/images/suoding-bai.png' : '/static/images/suoding.png'" class="icon-14 mr-5" alt="">
                  <div>锁定预算</div>
                </div>
              </div>
              <div v-if="permission.includes('basic')" class="flex">
                <div class="flex align-center mr-5 " :class="btnIndex === 9 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(9)" @mouseleave="leave1(9)" v-if="budgetGroup.changeLockStatus === 0" @click="changeLockStatus(1)">
                  <img :src="btnIndex === 9 ? '/static/images/suoding-bai.png' : '/static/images/suoding.png'" class="icon-14 mr-5" alt="">
                  <div>变更锁定</div>
                </div>
                <div class="flex align-center mr-5 " :class="btnIndex === 10 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(10)" @mouseleave="leave1(10)" v-if="budgetGroup.changeLockStatus === 1" @click="changeLockStatus(0)">
                  <img :src="btnIndex === 10 ? '/static/images/chehui-bai.png' : '/static/images/chehui.png'" class="icon-14 mr-5" alt="">
                  <div>撤回变更锁定</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" v-else>
            <div class="flex align-center mr-5 font-12-e2 btn-24-border-e2-f3f4f7" v-for="(item, index) in btnRight" v-if="permission.indexOf(item.permission) !== -1" :key="index">
              <img :src="item.icon" class="icon-14 mr-5" alt="">
              <div>{{item.name}}</div>
            </div>
          </div>
        </div>
        <!--报价模板-->
        <div v-else class="flex">
          <div class="flex">
            <!--<div class="flex align-center mr-5" @click="importDialog = true" :class="status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(1)" @mouseleave="leave1(1)">-->
            <!--<img :src="status === 2 ? '/static/images/daoru-hui.png' : btnIndex === 1 ? '/static/images/daoru-bai.png' : '/static/images/daoru.png'" class="icon-14 mr-5" alt="">-->
            <!--{{group === 1 ? '导入概算' : '导入预算'}}-->
            <!--</div>-->
            <div class="flex align-center mr-5 " :class="status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 2 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(2)" @mouseleave="leave1(2)" @click="exportBudget">
              <img :src="status === 2 ? '/static/images/daochu-hui.png' : btnIndex === 2 ? '/static/images/daochu-bai.png' : '/static/images/daochu.png'" class="icon-14 mr-5" alt="">
              <div>导出预算</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="flex">
            <div class="flex align-center mr-5 " :class="status === 2 ? 'btn-24-border-e2-f3f4f7' : btnIndex === 3 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(3)" @mouseleave="leave1(3)" @click="sumSave" v-if="!define && permission.includes('summary')">
              <img :src="status === 2 ? '/static/images/huizong-hui.png' : btnIndex === 3 ? '/static/images/huizong-bai.png' : '/static/images/huizong.png'" class="icon-14 mr-5" alt="">
              <div>汇总保存</div>
            </div>
            <div class="flex align-center mr-5 " :class="btnIndex === 4 ? 'btn-24-bg-46b8b0' : 'btn-24-border-30313a-e2' " @mouseenter="enter1(4)" @mouseleave="leave1(4)" @click="isReportShow = true">
              <img :src="btnIndex === 4 ? '/static/images/daying-bai.png' : '/static/images/daying.png'" class="icon-14 mr-5" alt="">
              <div>打印</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="hr mb-10"></div> -->
    <!--房间包-->
    <div class="mtb-10 flex flex-wrap" v-if="parseInt(define) === 2">
      <div class="flex align-center mr-5" :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(0)" @mouseleave="leave(0)" @click="addRoom">
        <img :src="Index === 0 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
        <div>新增房间</div>
      </div>
      <div class="flex align-center mr-5" :class="Index === 3 ? 'btn-24-bg-ff5555' : 'btn-24-bd-30313a' " @mouseenter="enter(3)" @mouseleave="leave(3)" @click="deleteRoom">
        <img :src="Index === 3 ? '/static/images/shanchu1-bai.png' : '/static/images/shanchu1.png'" class="icon-12-14 mr-5" alt="">
        <div>删除房间</div>
      </div>
    </div>
    <!--客户预算-->
    <div v-else-if="parseInt(define) !== 1">
      <div v-if="budgetGroup.changeLockStatus !== 1">
        <div class="mb-10 flex flex-wrap align-center" v-if="budgetId">
          <div class="flex" v-if="permission.includes('basic')">
            <div v-if="permission.includes('addRoom')" class="flex align-center mr-5" :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(0)" @mouseleave="leave(0)" @click="addRoom">
              <img :src="status === 2 ? '/static/images/add-hui.png' : Index === 0 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
              <div>新增房间</div>
            </div>
            <div class="flex align-center mr-5" :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(1)" @mouseleave="leave(1)" @click="copyRoom">
              <img :src="status === 2 ? '/static/images/fuzhi-hui.png' : Index === 1 ? '/static/images/fuzhi-bai.png' : '/static/images/fuzhi.png'" class="icon-14 mr-5" alt="">
              <div>复制房间</div>
            </div>
            <div class="flex align-center mr-5" :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 2 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(2)" @mouseleave="leave(2)" @click="addRoomBag">
              <img :src="status === 2 ? '/static/images/add-hui.png' : Index === 2 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
              <div>新增房间包</div>
            </div>
            <div class="flex align-center mr-5" :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 3 ? 'btn-24-bg-ff5555' : 'btn-24-bd-30313a' " @mouseenter="enter(3)" @mouseleave="leave(3)" @click="deleteRoom">
              <img :src="status === 2 ? '/static/images/shanchu1-hui.png' : Index === 3 ? '/static/images/shanchu1-bai.png' : '/static/images/shanchu1.png'" class="icon-12-14 mr-5" alt="">
              <div>删除房间</div>
            </div>
          </div>
        </div>
        <div class="mtb-10 flex flex-wrap" v-else>
          <div class="flex align-center mr-5 font-12-e2 btn-24-border-e2-ffffff" v-for="(item, index) in btnRoom" v-if="permission.indexOf(item.permission) !== -1" :key="index">
            <img :src="item.icon" class="icon-14 mr-5" alt="">
            <div>{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--报价模板-->
    <div class="mtb-10 flex flex-wrap" v-else>
      <div class="flex align-center mr-5 mb-5 " :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(0)" @mouseleave="leave(0)" @click="addRoom">
        <img :src="status === 2 ? '/static/images/add-hui.png' : Index === 0 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
        <div>新增房间</div>
      </div>
      <div class="flex align-center mr-5 mb-5 " :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(1)" @mouseleave="leave(1)" @click="copyRoom">
        <img :src="status === 2 ? '/static/images/fuzhi-hui.png' : Index === 1 ? '/static/images/fuzhi-bai.png' : '/static/images/fuzhi.png'" class="icon-14 mr-5" alt="">
        <div>复制房间</div>
      </div>
      <div class="flex align-center mr-5 mb-5 " :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 2 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(2)" @mouseleave="leave(2)" @click="addRoomBag">
        <img :src="status === 2 ? '/static/images/add-hui.png' : Index === 2 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
        <div>新增房间包</div>
      </div>
      <div class="flex align-center mr-5 mb-5 " :class="status === 2 ? 'btn-24-border-e2-ffffff' : Index === 3 ? 'btn-24-bg-ff5555' : 'btn-24-bd-30313a' " @mouseenter="enter(3)" @mouseleave="leave(3)" @click="deleteRoom">
        <img :src="status === 2 ? '/static/images/shanchu1-hui.png' : Index === 3 ? '/static/images/shanchu1-bai.png' : '/static/images/shanchu1.png'" class="icon-12-14 mr-5" alt="">
        <div>删除房间</div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="flex-1 h-0">
      <erp-table :is-edit="true" ref="erpTableRoom" :customs="[{field: 'isGive', visible: isColVisible}, {field: 'formula', visible: isColVisible}, {field: 'budgetAmount', visible: colVisible}, {field: 'increaseDecreaseAmount', visible: lockSave}, {field: 'settlementAmount', visible: lockSave}]" :table-data="tableData" :loading="loading" :column-data="columnData" @on-into="onInto" @on-give="onGive" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
    </div>
    <!--导入预算-->
    <el-dialog title="导入预算" :visible.sync="importDialog" width="357px" class="">
      <div class="p-38">
        <div class="text-center pb-20" style="border-bottom: 1px dashed #e2e2e2;">
          <div class="flex justify-center"><img src="/static/images/tip.png" class="icon-50 mb-20" alt=""></div>
          <div class="font-12-ff5555">注意：您将导入预算报价</div>
          <div class="font-12-ff5555">这将覆盖您原有的预算模板，且不可恢复！</div>
        </div>
        <div class="mt-20 text-center font-12-30313a">请选择是否导入预算：</div>
        <el-upload multiple name="file" :httpRequest="httpRequestImg" :action="upload" :show-file-list="false" :before-upload="beforeImgUpload">
          <div class="btnImport" style="margin: 20px auto 10px auto">导入预算</div>
        </el-upload>
        <button class="btnImport cursor" style="margin: 0 auto" @click="importDialog = false">取消导入</button>
      </div>
    </el-dialog>
    <!--模板选择-->
    <el-dialog title="选择预算模板" :visible.sync="templateDialog" width="65%" class="">
      <div class="pl-20">
        <div class="flex ptb-20">
          <img src="/static/images/jinggao.png" class="icon-14 mr-5" alt="">
          <div class="font-12-ff5555">注意：选择预算模板将会覆盖原有预算，且不可恢复，请确认后谨慎操作！</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-378 bg-f3f4f7 h-167 mr-20 mb-20" v-for="(item,index) in template" :key="index">
            <div class="flex p-20 align-center border-b-e2">
              <div class="flex-column text-left">
                <div class="font-18-30313a">{{item.name}}</div>
                <div class="font-12-b9b9b9">创建日期：{{item.createTime ? Utils.formatTime(item.createTime) : '-'}}</div>
              </div>
              <div class="flex flex-1 justify-end" @click="importBtn(item)"><button class="btn-30-border-30313a-small flex-shrink" style="width:46px">导入</button></div>
            </div>
            <div class="p-20 text-left">
              <div class="font-12-b9b9b9">模板描述：</div>
              <div class="font-12-b9b9b9">{{item.description ? item.description : '暂无描述哟'}}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--导入模板提示-->
    <el-dialog title="提示" :show-close="false" :visible.sync="tipDialog" width="357px" class="handlePlan">
      <div class="text-center ptb-20 mtb-20">
        <div class="flex justify-center"><img src="/static/images/tip.png" class="icon-50 mb-20" alt=""></div>
        <div class="font-12-ff5555">注意：您确定导入“{{temporaryMsg.name}}”？</div>
        <div class="font-12-ff5555">这将覆盖您原有的预算模板，且不可恢复！</div>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10" @click="closeTip">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="subTemplateTip">确定</div>
      </div>
    </el-dialog>
    <!--新增房间-->
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="添加房间" :visible.sync="roomShow" @closed="onCloseRoom">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">名称：</div>
          <el-input v-model="room.name" class="flex-1" placeholder="请输入名称"></el-input>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">备注：</div>
          <el-input type="textarea" v-model="room.remark" :row="3" class="flex-1" placeholder="请输入备注"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseRoom">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="onSubmitRoom">确定</div>
      </div>
    </el-dialog>
    <!--新增房间包-->
    <el-dialog title="新增房间包" :visible.sync="roomDialog" width="526px" class="">
      <div style="height:300px">
        <erp-table ref="erpTable" :table-data="tableDataRoom" :loading="loading" :column-data="columnData1Room" @on-add="onAdd"></erp-table>
      </div>
    </el-dialog>
    <!--打印-->
    <el-dialog title="打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="7" :id="this.budgetId"></report>
    </el-dialog>
  </div>
</template>
<!--define 1报价模板 2房间包-->
<script>
import ErpTable from '../../../components/ErpTable'
import Report from '../../../components/Report'
export default {
  name: 'budgetQuotation',
  components: { ErpTable, Report },
  props: ['titleName', 'budgetGroup', 'group', 'info', 'selectedTemplate', 'selectedTemplateId', 'define', 'permission', 'budgetName'],
  watch: {
    budgetGroup (newVal) {
      this.budgetGroupInner = newVal
      console.log(newVal.id)
      if (newVal.id) {
        this.budgetId = newVal.id
        this.status = newVal.status
        if (this.status === 1 || this.status === 2) {
          this.lockSave = true
        } else {
          this.lockSave = false
        }
        this.budgetRoom()
      } else {
        console.log(888888)
        this.tableData = []
      }
      this.budgetShow = true
    },
    selectedTemplate (newVal) {
      this.selectedTemplate = newVal
      if (newVal.id) {
        this.budgetId = newVal.id
      } else {
        console.log(999999)
        this.tableData = []
      }
    }
  },
  data () {
    return {
      upload: `${this.$store.state.API_URL_9010}/budget/import`,
      isColVisible: false,
      colVisible: true,
      lockSave: false,
      budgetId: null,
      budgetShow: false,
      user: null,
      status: null,
      Index: -1,
      btnIndex: -1,
      loading: false,
      isReportShow: false,
      temporaryMsg: '',
      budgetGroupInner: {},
      templateDetail: '',
      isLock: 0,
      btnLeft: [
        // {
        //   name: '导入预算',
        //   icon: '/static/images/daoru-hui.png',
        //   permission: 'basic'
        // },
        {
          name: '导出预算',
          icon: '/static/images/daochu-hui.png',
          permission: 'basic'
        }
      ],
      btnRight: [
        {
          name: '汇总保存',
          icon: '/static/images/huizong-hui.png',
          permission: 'summary'
        },
        {
          name: '打印',
          icon: '/static/images/daying-hui.png',
          permission: 'print'
        },
        // {
        //   name: '撤回预算',
        //   icon: '/static/images/chehui-hui.png'
        // },
        {
          name: '锁定预算',
          icon: '/static/images/suoding-hui.png',
          permission: 'lockSave'
        }
      ],
      btnRoom: [
        {
          name: '新增房间',
          icon: '/static/images/add-hui.png',
          permission: 'basic'
        },
        {
          name: '复制房间',
          icon: '/static/images/fuzhi-hui.png',
          permission: 'basic'
        },
        {
          name: '新增房间包',
          icon: '/static/images/add-hui.png',
          permission: 'basic'
        },
        {
          name: '删除房间',
          icon: '/static/images/shanchu1-hui.png',
          permission: 'basic'
        }
      ],
      tableFooter: [
        {
          columns: ['budgetAmount', 'increaseDecreaseAmount', 'settlementAmount'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'selection',
          width: '40'
        }, {
          field: 'operate',
          title: '操作',
          width: '80',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '进入',
            methodName: 'on-into'
          }]
        }, {
          field: 'sort',
          title: '序号',
          width: '60',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'isGive',
          title: '赠送',
          width: '50',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isGive',
            methodName: 'on-give',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        }, {
          field: 'name',
          title: '房间名',
          width: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'formula',
          title: '计算式',
          width: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'budgetAmount',
          title: '预算金额',
          width: '100'
        }, {
          field: 'increaseDecreaseAmount',
          title: '增减金额',
          width: '100'
        }, {
          field: 'settlementAmount',
          title: '结算金额',
          width: '100'
        }, {
          field: 'remark',
          title: '备注',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      columnData1Room: [
        {
          field: 'operate',
          title: '操作',
          width: '80',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '新增',
            methodName: 'on-add'
          }]
        }, {
          field: 'name',
          title: '房间名',
          width: '150'
        }, {
          field: 'address',
          title: '备注',
          minWidth: '200'
        }
      ],
      tableData: [],
      tableDataRoom: [],
      importDialog: false,
      templateDialog: false,
      template: [],
      tipDialog: false,
      roomDialog: false,
      roomShow: false,
      room: {
        name: '',
        remark: ''
      },
      Arr: []

    }
  },
  created () {
  },
  mounted () {
    this.refresh()
    if (this.define) {
      this.isColVisible = true
      this.colVisible = false
    }
    if (this.status === 1 || this.status === 2) {
      this.lockSave = true
    } else {
      this.lockSave = false
    }
  },
  methods: {
    refresh () {
      this.budgetGroupInner = this.budgetGroup
      if (this.define === 1) { // define 模板定义
        this.budgetId = this.selectedTemplateId
      } else if (!this.define) {
        if (this.budgetGroupInner.id) {
          this.status = this.budgetGroupInner.status
          this.budgetId = this.budgetGroupInner.id
        }
      }
      this.budgetRoom()
    },
    exportBudget () {
      if (this.define === 1) {
        window.location.href = this.$store.state.API_URL_9010 + '/budgetTemplate/export?id=' + this.budgetId
      } else {
        window.location.href = this.$store.state.API_URL_9010 + '/budget/export?id=' + this.budgetId
      }
    },
    importBudget () { // 导入预算
      if (parseInt(this.status) !== 1 && parseInt(this.status) !== 2) {
        this.importDialog = true
      }
    },
    beforeImgUpload () { },
    httpRequestImg (e) {
      this.importDialog = false
      let formData = new FormData()
      let port = ''
      if (this.define === 1) {
        formData.append('file', e.file)
        formData.append('companyId', this.$store.state.companyId)
        port = '/budgetTemplate/import'
      } else {
        formData.append('file', e.file)
        formData.append('customerId', this.info.id)
        formData.append('group', this.group)
        port = '/budget/import'
      }
      this.axios.post(`${this.$store.state.API_URL_9010}` + port, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: '导入成功',
            type: 'success'
          })
          if (!this.define) {
            this.budgetId = onloadRes.data.data.id
            this.budgetGroupId = onloadRes.data.data.id
            this.$store.dispatch('setBudgetGroupId', onloadRes.data.data.id)
            // this.$parent.$parent.$parent.budgetGroupId = onloadRes.data.data.id
            // this.$parent.$parent.$parent.getBudgetGroup()
            this.budgetRoom()
          }
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message.error('导入失败！')
      })
    },
    getBudgetTemplate () { // 获取预算模板
      let params = {
        companyId: this.$store.state.companyId,
        status: 1
        // name: this.budgetName
      }
      this.axios.post('budgetTemplate/list', params).then(res => {
        if (res.data.success) {
          this.template = res.data.data
        }
      })
    },
    selectTemplate () {
      if (this.status !== 1 && this.status !== 2) {
        this.templateDialog = true
        this.getBudgetTemplate()
      }
    },
    importBtn (item) { // 导入模板
      this.tipDialog = true
      this.temporaryMsg = item
    },
    subTemplateTip () {
      this.tipDialog = false
      this.templateDialog = false
      this.templateDetail = this.temporaryMsg
      let params = {
        templateId: this.templateDetail.id,
        customerId: this.info.id,
        group: this.group
      }
      this.axios.post('budget/selectTemplate', params).then(res => {
        if (res.data.success) {
          this.budgetId = res.data.data.id
          this.$store.dispatch('setBudgetGroupId', res.data.data.id)
          this.$message({
            message: '预算模板导入成功',
            type: 'success'
          })
          this.$router.replace({ name: 'ManagerBudget', query: { id: this.$parent.$route.query.id, parent: this.$parent.$route.query.parent, budgetGroupId: this.budgetId, group: this.$parent.$route.query.group } })
          this.$emit('refresh')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    closeTip () {
      this.tipDialog = false
    },
    changeStatus (status) { // 改变状态
      let params = {
        id: this.budgetId,
        changeStatus: status
      }
      this.axios.post('budget/changeStatus', params).then(res => {
        if (res.data.success) {
          let selectedBudget = {
            user: this.info.id,
            budgetGroupInner: res.data.data
          }
          this.budgetGroupInner = res.data.data
          this.$store.dispatch('setBudgetId', selectedBudget)
          this.status = res.data.data.status
          if (this.status === 1 || this.status === 2) {
            this.lockSave = true
          } else {
            this.lockSave = false
          }
          this.$message.success('修改状态成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    // 变更锁定
    changeLockStatus (status) {
      this.$confirm(`是否确定${status === 0 ? '撤回变更锁定' : '锁定变更'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post('budget/modify', {
          id: this.budgetId,
          changeLockStatus: status
        }).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.$parent.$parent.$parent.isRefresh()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {
      })
    },
    sumSave () { // 汇总保存
      let params = {
        id: this.budgetId
      }
      this.axios.post('budget/summary', params).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
        }
        this.budgetRoom()
      })
    },
    budgetRoom () { // 房间列表
      if (this.budgetId) {
        this.loading = true
        let params = {
          budgetId: this.budgetId
        }
        let port = ''
        if (this.define === 1) {
          port = 'budgetRoomTemplate/list'
        } else {
          port = 'budgetRoom/list'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.loading = false
            this.tableData = res.data.data
            console.log(this.tableData)
          }
        })
      }
      if (this.define === 2) { // 房间包列表
        let params = {
          companyId: this.$store.state.companyId
        }
        this.axios.post('budgetRoomPackage/list', params).then(res => {
          if (res.data.success) {
            this.tableData = res.data.data
          }
        })
      }
      console.log(this.tableData)
    },
    onGive (row) {
      this.onModifyRow(row)
    },
    onModifyRow (row, cloumn, colName) {
      let params = null
      params = {
        'id': row.id,
        'name': row.name,
        'budgetAmount': row.budgetAmount,
        'settlementAmount': row.settlementAmount,
        'sort': row.sort,
        'remark': row.remark,
        'isGive': row.isGive,
        'formula': row.formula
      }
      if (this.define === 2) {
        params.companyId = row.companyId
      } else {
        params.budgetId = row.budgetId
      }
      let port = ''
      if (this.define === 1) {
        port = 'budgetRoomTemplate/modify'
      } else if (this.define === 2) {
        port = 'budgetRoomPackage/modify'
      } else {
        port = 'budgetRoom/modify'
      }
      this.axios.post(port, params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.budgetRoom()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    copyRoom () { // 复制房间
      let params = {}
      let customerArr = this.$refs.erpTableRoom.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择房间`,
          type: 'warning'
        })
      } else {
        params.id = customerArr[0].id
        let port = ''
        if (this.define) {
          port = 'budgetRoomTemplate/copyRoom'
        } else {
          port = 'budgetRoom/copyRoom'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '复制房间成功',
              type: 'success'
            })
            this.budgetRoom()
            params = {}
          }
        })
      }
    },
    addRoom () { // 新增房间
      this.roomShow = true
      this.Arr = this.$refs.erpTableRoom.getSelectEvent()
    },
    onSubmitRoom () {
      let targetId = ''
      let isLast = null
      if (this.Arr.length > 0) {
        targetId = this.Arr[0].id
        isLast = null
      } else if (this.tableData.length > 0) {
        targetId = this.tableData[this.tableData.length - 1].id
        isLast = 1
      } else {
        isLast = null
        targetId = -1
      }
      let params = {}
      if (!this.room.name) {
        this.$message.warning('请输入房间名称')
      } else {
        params = this.room
        params.targetId = targetId
        params.isLast = isLast
        if (this.define === 2) {
          params.companyId = this.$store.state.companyId
        } else {
          params.budgetId = this.budgetId
        }
        let port = ''
        if (this.define === 1) {
          port = 'budgetRoomTemplate/save'
        } else if (this.define === 2) {
          port = 'budgetRoomPackage/save'
        } else {
          port = 'budgetRoom/save'
        }
        this.axios.post(port, params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '添加房间成功',
              type: 'success'
            })
            this.roomShow = false
            // this.budgetRoom()
            let position = -1
            if (this.Arr.length > 0) {
              position = this.Arr[0]
            }
            this.$refs.erpTableRoom.insertAt(res.data.data, position)
            this.budgetRoom()
            this.room.name = ''
            this.room.remark = ''
            this.Arr = []
            targetId = ''
            isLast = null
          } else {
            this.$message({
              message: '添加房间失败',
              type: 'error'
            })
          }
        })
      }
    },
    onCloseRoom () {
      this.roomShow = false
      this.room.name = ''
      this.room.remark = ''
    },
    addRoomBag () {
      this.roomDialog = true
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('budgetRoomPackage/list', params).then(res => {
        if (res.data.success) {
          this.tableDataRoom = res.data.data
        }
      })
    },
    onAdd (row) { // 房间包新增
      let params = {
        budgetId: this.budgetId,
        packageId: row.id
      }
      let port = ''
      if (this.define === 1) {
        port = 'budgetRoomTemplate/selectPackage'
      } else {
        port = 'budgetRoom/selectPackage'
      }
      this.axios.post(port, params).then(res => {
        if (res.data.success) {
          this.budgetRoom()
          this.$message({
            message: '添加房间成功',
            type: 'success'
          })
          this.roomDialog = false
        }
      })
    },
    deleteRoom () { // 删除房间
      let customerArr = this.$refs.erpTableRoom.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择房间`,
          type: 'warning'
        })
      } else {
        let params = {}
        let ids = ''
        customerArr.forEach(item => {
          if (ids) {
            ids = ids + ',' + item.id
          } else {
            ids = item.id
          }
        })
        params.ids = ids
        let port = ''
        if (this.define === 1) {
          port = 'budgetRoomTemplate/deleteByIds'
        } else if (this.define === 2) {
          port = 'budgetRoomPackage/deleteByIds'
        } else {
          port = 'budgetRoom/deleteByIds'
        }
        this.axios.post(port, this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功！'
            })
            this.budgetRoom()
            ids = ''
          } else {
            this.$message({
              type: 'waring',
              message: res.data.msg
            })
          }
        })
      }
    },
    onInto (row) {
      console.log(this.define)
      if (this.define) {
        this.$router.push({ path: '/customerManagement/enterRoom', query: { budgetRoomId: row.id, define: this.define, budgetId: this.budgetId } })
      } else {
        this.$router.push({ path: '/customerManagement/enterRoom', query: { budgetRoomId: row.id, budgetId: this.budgetId, status: this.status, changeLockStatus: this.budgetGroup.changeLockStatus } })
      }
    },
    enter (e) {
      this.Index = e
    },
    leave () {
      this.Index = -1
    },
    enter1 (e) {
      this.btnIndex = e
    },
    leave1 () {
      this.btnIndex = -1
    }
  }
}
</script>

<style scoped>
.p-38 {
  padding: 38px;
}
.pb-20 {
  padding-bottom: 20px;
}
.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}
.line {
  height: 24px;
  background: #f3f4f7;
  width: 1px;
  margin: 0 20px;
}
.btnImport {
  width: 190px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #30313a;
  font-size: 12px;
  color: #30313a;
}
.btnImport :active,
.btnImport :hover {
  width: 190px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #46b8b0;
  border-radius: 4px;
  border: solid 1px #46b8b0;
  font-size: 12px;
  color: #ffffff;
}
.w-378 {
  width: 378px;
}
.h-167 {
  height: 167px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/budgetItem/budgetQuotation.vue